<section class="flight_loader_section">
  <div class="loaderLoding">
    <img src="../../../../../assets/belairtrip_assets/svg_icon/belairloader.gif" alt="Flight Loader" class="img-fluid">
    <div class="content_loader">
      <!-- <h3>Searching for <span>{{list.travelDetail}}</span> flight on <span>{{list.deptDate | date : 'EEE, MMM dd, YYYY'}} <ng-container *ngIf="list.returnDate !== ''">&nbsp;- {{list.returnDate | date : 'EEE, MMM dd, YYYY'}}</ng-container></span></h3> -->
      <!-- <p>Just a moment, we are searching for the flights on this route.</p> -->
    </div>
  </div>
</section>
